import { getAxiosClient } from "../../axios-client";
import {
  OfferSubcontractorRefuseRequestBody,
  OfferSubcontractorRefuseResponse,
} from "./types";

const axiosClient = getAxiosClient();
export const offerSubcontractorRefuse = async (
  body: OfferSubcontractorRefuseRequestBody
) => {
  return await axiosClient.ax.post<OfferSubcontractorRefuseResponse>(
    "/Offers/OfferSubcontractorRefuse",
    body
  );
};
